WAU.Quickshop = {
	cache: new Map(),
	init: function init() {
		var selectors = {
			quickviewButton: '.js-quickview-trigger'
		};

		if (document.getElementById('quickshopTemplate')) {
			document.getElementById('quickshopTemplate').innerHTML = '';
		}

		document.querySelectorAll(selectors.quickviewButton).forEach((button) => {
			button.addEventListener('click', function (event) {
				event.preventDefault();
				const trigger = event.currentTarget;
				const preservePlpBagIcon = trigger.classList.contains('plp-card__bag');
				if (!preservePlpBagIcon) trigger.classList.add('loading-quickshop');

				var productUrl = this.dataset.productUrl;
				productUrl = WAU.Quickshop.cleanUrl(productUrl, 'variant');

				let singleVariant = trigger.hasAttribute('data-quick-add');

				WAU.Quickshop.getTemplate(productUrl, singleVariant, trigger);
			});
		});

		// Evento para fechar a Modal
		document.addEventListener('click', function (e) {
			if (e.target.closest('.js-modal-close') || e.target.id === 'modal-quickview') {
				WAU.Quickshop.hideModal();
			}
			if (e.target.closest('.js-slideout-close') || e.target.id === 'slideout-quickview') {
				WAU.Quickshop.hideDrawer();
			}
		});
	},
	prefetchQuickview: async function ({ dataset }) {
		const { productUrl } = dataset;
		const cleanUrl = WAU.Quickshop.cleanUrl(productUrl);

		if (!WAU.Quickshop.cache.has(cleanUrl)) {
			const response = await fetch(productUrl);
			const htmlText = await response.text();
			WAU.Quickshop.cache.set(cleanUrl, htmlText);
		}
	},
	formatTemplate: function formatTemplate(response) {
		const doc = new DOMParser().parseFromString(response, 'text/html');

		// Acessa o DocumentFragment interno do <template> retornado pela Shopify
		let searchScope = doc;
		const shopifyTemplateTag = doc.querySelector('template#quickshop') || doc.querySelector('template');
		if (shopifyTemplateTag && shopifyTemplateTag.content) {
			searchScope = shopifyTemplateTag.content;
		}

		// Extrai apenas o HTML interno do #quickshopTemplate (ignorando a div com display:none)
		const templateEl = searchScope.querySelector('#quickshopTemplate') || doc.querySelector('#quickshopTemplate');
		if (templateEl) return templateEl.innerHTML;

		const productEl = searchScope.querySelector('.quickshop-product') || doc.querySelector('.quickshop-product');
		if (productEl) return productEl.outerHTML;

		return response;
	},
	showModal: function showModal(trigger) {
		if (trigger) {
			trigger.setAttribute('data-wau-modal-target', 'quickview');
			trigger.classList.add('js-modal-open');
		}

		const modal = document.getElementById('modal-quickview');
		if (modal) modal.classList.add('is-open', 'active');
		document.body.classList.add('modal--open');

		if (typeof WAU !== 'undefined' && WAU.Modal && typeof WAU.Modal._openByName === 'function') {
			try { WAU.Modal._openByName("modal-quickview"); } catch (e) { }
		}
	},
	hideModal: function hideModal() {
		const modal = document.getElementById('modal-quickview');
		if (modal) modal.classList.remove('is-open', 'active');
		document.body.classList.remove('modal--open');

		const content = document.querySelector('#modal-quickview .js-quickview-content');
		if (content) content.innerHTML = '';

		if (typeof WAU !== 'undefined' && WAU.Modal && typeof WAU.Modal._closeByName === 'function') {
			try { WAU.Modal._closeByName("modal-quickview"); } catch (e) { }
		}
	},
	showDrawer: function showDrawer(trigger) {
		if (trigger) {
			trigger.setAttribute('data-wau-slideout-target', 'quickview');
			trigger.setAttribute('data-slideout-direction', 'right');
			trigger.classList.add('js-slideout-open');
		}
		const drawer = document.getElementById('slideout-quickview');
		if (drawer) {
			drawer.classList.add('is-open');
		}
		if (typeof WAU !== 'undefined' && WAU.Slideout && typeof WAU.Slideout._openByName === 'function') {
			try { WAU.Slideout._openByName("slideout-quickview"); } catch (e) { }
		}
	},
	hideDrawer: function hideDrawer() {
		const drawer = document.getElementById('slideout-quickview');
		if (drawer) {
			drawer.classList.remove('is-open');
		}
		const content = document.querySelector('#slideout-quickview .js-quickview-content');
		if (content) content.innerHTML = '';

		if (typeof WAU !== 'undefined' && WAU.Slideout && typeof WAU.Slideout._closeByName === 'function') {
			try { WAU.Slideout._closeByName("slideout-quickview"); } catch (e) { }
		}
	},
	cleanUrl: function cleanUrl(url) {
		return url.split('?')[0] + '?view=quick';
	},
	enableDragScroll: function enableDragScroll(slider) {
		if (!slider) return;
		let isDown = false;
		let startX;
		let scrollLeft;

		slider.addEventListener('mousedown', (e) => {
			isDown = true;
			slider.classList.add('active');
			startX = e.pageX - slider.offsetLeft;
			scrollLeft = slider.scrollLeft;
		});
		slider.addEventListener('mouseleave', () => { isDown = false; });
		slider.addEventListener('mouseup', () => { isDown = false; });
		slider.addEventListener('mousemove', (e) => {
			if (!isDown) return;
			e.preventDefault();
			const x = e.pageX - slider.offsetLeft;
			const walk = (x - startX) * 2;
			slider.scrollLeft = scrollLeft - walk;
		});
	},
	getTemplate: async function getTemplate(url, singleVariant, trigger) {
		try {
			let htmlText;

			if (WAU.Quickshop.cache.has(url)) {
				htmlText = WAU.Quickshop.cache.get(url);
			} else {
				const response = await fetch(url);
				htmlText = await response.text();
			}

			let content = WAU.Quickshop.formatTemplate(htmlText);

			const tempDiv = document.createElement('div');
			tempDiv.innerHTML = content;
			const quickshopItem = tempDiv.querySelector('.quickshop-product');
			const type = quickshopItem ? (quickshopItem.dataset.quickshopType || 'modal') : 'modal';

			const targetContainer = type === 'drawer'
				? document.querySelector('#slideout-quickview .js-quickview-content')
				: document.querySelector('#modal-quickview .js-quickview-content');

			if (targetContainer) {
				targetContainer.innerHTML = content;
			}

			let context = targetContainer ? (targetContainer.querySelector('.quickshop-product') || targetContainer) : null;

			if (context) {
				const scrollGallery = context.querySelector('.js-scroll-gallery');
				if (scrollGallery) {
					WAU.Quickshop.enableDragScroll(scrollGallery);
				}

				const sizeButtons = context.querySelectorAll('.size-swatch-btn');
				const submitBtn = context.querySelector('.custom-quickview-submit');
				const variantInput = context.querySelector('#quickshop-variant-id');

				if (sizeButtons.length > 0 && submitBtn && variantInput) {
					sizeButtons.forEach(button => {
						button.addEventListener('click', function (e) {
							e.preventDefault();
							if (this.classList.contains('is-disabled')) return;

							sizeButtons.forEach(btn => btn.classList.remove('is-selected'));
							this.classList.add('is-selected');

							variantInput.value = this.dataset.variantId;
							variantInput.removeAttribute('disabled');
							submitBtn.removeAttribute('disabled');
						});
					});
				}

				if (context.querySelector('.js-ajax-submit')) {
					context.querySelector('.js-ajax-submit').addEventListener('click', function (e) {
						e.preventDefault();
						if (this.hasAttribute('disabled')) return false;

						var addToCartForm = this.closest('form');
						let cartConfig = document.getElementById('cart-config');
						if (!cartConfig) return false;
						cartConfig = JSON.parse(cartConfig.innerHTML || '{}');

						WAU.AjaxCart.addToCart(addToCartForm, null, cartConfig, true, false);
						return false;
					});
				}
			}

			if (type === 'drawer') {
				WAU.Quickshop.showDrawer(trigger);
			} else {
				WAU.Quickshop.showModal(trigger);
			}

			if (trigger) trigger.classList.remove('loading-quickshop');

		} catch (error) {
			console.log(error);
		}
	}
};

document.addEventListener('DOMContentLoaded', function () {
	WAU.Quickshop.init();
});
